module.exports = __webpack_public_path__ + "7514e522e462cb166871500dde4bae88.svg";